<div class="student">
        <div class="studentInfo" matTooltip="{{student.Name}}"><b>{{student.Name}}</b> </div>
      
    
    <div class="studentActions">

        <div class="active-lessons" [ngStyle]="{'color': (student.ActiveLessons == 0) ? 'red' : 'black'}">
            Active Lessons: {{student.ActiveLessons}}
         
        </div>


        <div class="lastSubmit" *ngIf="student.LastAssignmentSubmitDate">
            Last Submission: {{student.LastAssignmentSubmitDate}} 
        </div>
        <div class="lastSubmit" *ngIf="!student.LastAssignmentSubmitDate">
            &nbsp;
        </div>
        <div class="studentAction" >
            <div *ngIf="student.ActiveLessons == 0">
                <a mat-raised-button 
                href="/LessonProgress/LessonProgress.aspx?StudentID={{student.ID}}&ClassID={{classData.ID}}&NeedsAssignment=true"
                (click)="saveState($event)"
                >
                <i class="fas fa-hand-holding-box"></i>
                &nbsp; 
                Assign Lesson 
                </a>
            </div>

            <div *ngIf="student.ActiveLessons > 0">
                <a mat-stroked-button 
                href="/LessonProgress/LessonProgress.aspx?StudentID={{student.ID}}&ClassID={{classData.ID}}&NeedsAssignment=true"
                (click)="saveState($event)"
                >
                <i class="fas fa-hand-holding-box"></i>
                &nbsp; 
                Assign Lesson 
                </a>
            </div>
            
        </div>

        <div class="studentAction">
            <button mat-raised-button 
            [disabled]="student && student.NeedsGradingCount == 0"
            routerLink="/ELearning/Student/{{student.ID}}/Class/{{classData.ID}}"
            [queryParams]="{studentName: student.Name}"
            (click)="saveState($event)"
            >
            <i class="fas fa-check-square"
            ></i> 
            &nbsp; 
            <span> Grade Lesson </span>
            </button>
            <div class="notificationBadge" *ngIf="student && student.NeedsGradingCount > 0">
                <app-notification-badge [displayString]="student.NeedsGradingCount" [size]="'small'"></app-notification-badge>
            </div>
        
        </div>
        <div class="studentAction">
            <button mat-raised-button
            [disabled]="student && student.NeedsGradeReleasedCount == 0" 
            routerLink="/ELearning/Student/{{student.ID}}/Class/{{classData.ID}}"
            [queryParams]="{studentName: student.Name}"
            (click)="saveState($event)"
            >
                <i class="fas fa-dove"></i>
                &nbsp; 
                <span> Release Grade </span>
            </button>
            <div class="notificationBadge" *ngIf="student && student.NeedsGradeReleasedCount > 0">
                <app-notification-badge [displayString]="student.NeedsGradeReleasedCount" [size]="'small'"></app-notification-badge>
            </div>
        </div>
    </div>
</div>